import { Table } from 'antd';
import styled from 'styled-components';

const TableStyle = styled(Table)`
  &&& {
    th.ant-table-cell {
      background: #f4f5f6 !important;
      text-transform: uppercase;
      font-size: 12px;
      color: #2b2828;
      font-weight: normal;
      padding-bottom: 25px;
      padding-top: 25px;
      border-bottom: none;
    }
    td.ant-table-cell {
      background: #f4f5f6 !important;
      border: none !important;
    }
    td.ant-table-cell .item-row {
      background: white;
      margin-bottom: 5px;
      height: 50px;
      display: flex;
      align-items: center;
    }

    td.ant-table-cell {
      &:first-child {
        .item-row {
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
          padding-left: 26px;
        }
      }
      &:last-child {
        .item-row {
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
          padding-right: 26px;
          display: flex;
          justify-content: flex-end;
        }
      }
      padding: 0 !important;
    }
    th.ant-table-cell {
      padding-left: 0 !important;
      &:first-child {
        padding-left: 26px !important;
      }
    }
  }
`;

export default TableStyle;
